var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1293 21.3138C14.1461 20.9741 14.2622 20.6468 14.4633 20.3725C14.6644 20.0982 14.9416 19.889 15.2605 19.7709C15.5794 19.6527 15.9261 19.6309 16.2573 19.708C16.5886 19.7851 16.8899 19.9578 17.1239 20.2046C17.3579 20.4514 17.5142 20.7616 17.5735 21.0964C17.6328 21.4313 17.5924 21.7763 17.4574 22.0884C17.3224 22.4006 17.0987 22.6662 16.814 22.8524C16.5294 23.0385 16.1964 23.137 15.8563 23.1356C15.6221 23.1332 15.3907 23.0838 15.176 22.9902C14.9613 22.8967 14.7676 22.7608 14.6065 22.5909C14.4454 22.4209 14.3201 22.2202 14.2381 22.0008C14.1561 21.7814 14.1191 21.5477 14.1293 21.3138ZM14.5468 11.0851L14.452 8.44727H17.2985L17.2036 11.0851L16.8051 18.0876H14.9833L14.5468 11.0851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaution);
export default __webpack_public_path__ + "static/media/ic_caution.da52888822b833ad2185d0704ae38e7f.svg";
export { ForwardRef as ReactComponent };